var EditModeItemView;

EditModeItemView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-mode-switcher-content',

	id: 'kitbuilder-mode-switcher-inner',

	ui: {
		previewButton: '#kitbuilder-mode-switcher-preview-input',
		previewLabel: '#kitbuilder-mode-switcher-preview',
		previewLabelA11y: '#kitbuilder-mode-switcher-preview .kitbuilder-screen-only'
	},

	events: {
		'change @ui.previewButton': 'onPreviewButtonChange'
	},

	initialize: function() {
		this.listenTo( kitbuilder.channels.dataEditMode, 'switch', this.onEditModeChanged );
	},

	getCurrentMode: function() {
		return this.ui.previewButton.is( ':checked' ) ? 'preview' : 'edit';
	},

	setMode: function( mode ) {
		this.ui.previewButton
			.prop( 'checked', 'preview' === mode )
			.trigger( 'change' );
	},

	toggleMode: function() {
		this.setMode( this.ui.previewButton.prop( 'checked' ) ? 'edit' : 'preview' );
	},

	onRender: function() {
		this.onEditModeChanged();
	},

	onPreviewButtonChange: function() {
		kitbuilder.changeEditMode( this.getCurrentMode() );
	},

	onEditModeChanged: function() {
		var activeMode = kitbuilder.channels.dataEditMode.request( 'activeMode' ),
			title = kitbuilder.translate( 'preview' === activeMode ? 'back_to_editor' : 'preview' );

		this.ui.previewLabel.attr( 'title', title );
		this.ui.previewLabelA11y.text( title );
	}
} );

module.exports = EditModeItemView;
